var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 17,
    r: 6.4,
    fill: "#1B2646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 36c0-6.9 5.6-10.8 12.5-10.8S33 29.1 33 36Z",
    fill: "#1B2646"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35.5,
    r: 8.3,
    fill: "#FFFFFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35.5,
    r: 6.6,
    fill: "none",
    stroke: "#1B2646",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLead);
export default __webpack_public_path__ + "static/media/status-lead.190fde1fb3fe01cecf6931dad362a3bc.svg";
export { ForwardRef as ReactComponent };